export const tableHeaderStyle = {
  background: '#f7f9fa',
  color: '#4e5051',
  textAlign: 'center',
  fontSize: '12px'
}

export const tableHeaderStyleBig = {
  background: '#f7f9fa',
  color: '#4e5051',
  textAlign: 'center',
  fontSize: '22px'
}

export const tableCellStyle = {
  textAlign: 'center'
}

export const tableCellStyleHighLight = {
  textAlign: 'center'
}
export const tableCellStyleBig = {
  textAlign: 'center',
  fontSize: '22px'
}



// WEBPACK FOOTER //
// ./src/settings/table.js